module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Bold.d77fdaed.woff";